import { onActivated, onDeactivated, readonly, ref, type Ref } from 'vue';

/**
 * False while a kept-alive ancestor holds the calling component deactivated:
 * left that way, a page is still mounted and its timers and animations still run.
 */
export function useIsActive(): Readonly<Ref<boolean>> {
  const active = ref(true);
  onActivated(() => (active.value = true));
  onDeactivated(() => (active.value = false));
  return readonly(active);
}
